// removed by extract-text-webpack-plugin
module.exports = {"title":"_1RW-HANcEK2pNjz5YB34OI","buttonNew":"_1py-noSyQIN7UhRg8WWBj7","searchField":"_2l4moiiClw-EG3carCq9Nd","table":"_2S9W-XlERR41GNlIrswKbD"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Locations/style.scss
// module id = 1247
// module chunks = 0